import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import dispatchCustomEvent from 'mex_components/app/scripts/events/dispatchCustomEvent';
import slideToggle from 'mex_components/app/scripts/animation/slideToggle';
import slideUp from 'mex_components/app/scripts/animation/slideUp';
import toggleClass from 'mex_components/app/scripts/elements/toggleClass';

let dropdownButton;
let dropdownOptions;

const handleClick = (event) => {
  // Toggle menu if the dropdown button, menu option,
  // Or the outside of the menu is clicked
  if (event.target == dropdownButton) {
    slideToggle(dropdownOptions);
  } else if (event.target.classList.contains('dropdown__option')) {
    updateMenu(event);
    slideToggle(dropdownOptions);
  } else {
    slideUp(dropdownOptions);
  }
};

const updateMenu = (event) => {
  dropdownButton.innerHTML = event.target.innerHTML;
  toggleClass(dropdownButton, 'button--secondary', true);
  toggleClass(dropdownButton, 'button--primary', false);

  dispatchCustomEvent(document, 'dropdown.change', {
    data: { value: event.target.dataset.value }
  });
};

const setupEventHandlers = () => {
  document.addEventListener('click', handleClick);
};

export function setup() {
  dropdownButton = document.querySelector('.dropdown .button--dropdown');
  dropdownOptions = document.querySelector('.dropdown .dropdown__options');

  if (!dropdownButton || !dropdownOptions) return;
  setupEventHandlers();
}

addStartupScript(setup);
